// Resolves an asset URL stored in the DB to a fully-qualified URL
// that the browser can load.
//
// Why this exists:
// Historically the admin saved uploaded image URLs as absolute URLs that
// embedded the preview hostname (e.g. https://xyz.preview.emergentagent.com/api/uploads/abc.png).
// When the preview hostname changes (forks, deploys, env resets), those URLs
// become unreachable even though the file is still on the server. This helper
// strips any embedded hostname pointing at an /api/uploads path and prefixes
// the CURRENT backend URL at render time, so images survive environment changes.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const resolveAsset = (url) => {
  if (!url || typeof url !== "string") return url;

  // If the URL embeds /api/uploads/... anywhere (even after a stale hostname),
  // normalize it to the current backend.
  const uploadsMatch = url.match(/\/api\/uploads\/[^\s?#]+(\?[^\s#]*)?(#.*)?$/);
  if (uploadsMatch) {
    return `${BACKEND_URL}${uploadsMatch[0]}`;
  }

  // Relative path starting with / -> prefix with backend
  if (url.startsWith("/")) {
    return `${BACKEND_URL}${url}`;
  }

  // Otherwise it's an external URL (pexels, customer-assets, data:, etc.) -> use as-is
  return url;
};
